module.exports = __webpack_public_path__ + "static/media/arrow-circle-down.435fb669.svg";